import { useChannel } from "./ws/useChannel";
import useQuery, { useRevalidate } from "./useQuery";
import useDebouncedCallback from "@ui/lib/hooks/useDebouncedCallback";
import useDistinctShape from "@ui/lib/hooks/useDistinctShape";

const PATH = "/settings" as const;

export const useSettings = () => {
  const revalidate = useRevalidate();

  const settings = useQuery(PATH).body;
  const callback = useDebouncedCallback(
    () => {
      void revalidate(PATH);
    },
    [revalidate],
    2_000,
    {
      leading: true,
      maxWait: 2_000,
      trailing: true,
    },
  );

  useChannel({ key: "settings" }, callback, true);

  return useDistinctShape(settings);
};

export type SettingIndex = ReturnType<typeof useSettings>;
